import { default as axiosBase } from 'axios';
import axiosRetry from 'axios-retry';
import { ajaxErrorsInterceptor, checkVersionInterceptor } from './utils';

let schemeAuth = '';

if ((window.location.protocol != 'https:' && window.location.protocol != 'http:') || location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
    var scheme = 'http';
    var authority = 'localhost';
    var port = '8081';
    schemeAuth = scheme+'://'+authority+':'+port;
}

const baseUrl = `${schemeAuth}/api/v1`;
const baseUrlV2 = `${schemeAuth}/api/v2`;

const axios = axiosBase.create({ baseURL: baseUrl, timeout: 30000, withCredentials: true });
const axiosGet = axiosBase.create({ baseURL: baseUrl, timeout: 30000, withCredentials: true });
axiosRetry(axiosGet);

const createAxiosMiddleware = axios => props => 
    axios.interceptors.response.use(checkVersionInterceptor(props), ajaxErrorsInterceptor(props));
export const createAxiosMiddlewareMain = createAxiosMiddleware(axios);
export const createAxiosMiddlewareRetry = createAxiosMiddleware(axiosGet);

//User
export const signupRequest = props => {
    return axios.post('/signup', props);
}
export const isEmailAvaible = (email, userId=false) => {
    return axios({
        method: userId ? 'put' : 'post',
        url: '/users/checkemailexistence',
        data: userId ? { email, userId } : { email }
    });
}

export const isCompanyEmailAvailable = (email) => {
    return axios({
        method: 'post',
        url: '/companies/checkemailexistence',
        data: { email }
    });
}

export const updateCompanyDetailsRequest = props => {
    return axios.put('/companies', props);
}
export const loginUser = loginProps => {
    return axios.post('/auth/login', {
        email: loginProps.email,
        password: loginProps.password
    });
}
export const logoutUser = token => axios.post('/auth/logout', { token });
export const impersonateUserRequest = userId => {
    return axios.post('/auth/impersonate', {
        id: userId
    });
}
export const resetPasswordRequest = requestEmail => {
    return axios.post('/auth/requestreset', {
        email: requestEmail,
    });
}
export const setNewPasswordRequest = props => {
    return axios.post('/auth/reset', props);
}
export const getCurrentUser = () => {
    return axios.get('/users/current');
}
export const getOnBehalfOfUsers = params => {
    return axiosGet.get('/users/onbehalfoflist', { params });
}
export const getUsersWithNotificationRequest = params => {
    return axiosGet.get('/users/withnotifications', { params });
}
export const getDailyUsersLogRequest = () => {
    return axiosGet.get('/users/today');
}

// Manage Notifications
export const getApprovedCompaniesRequest = () => {
    return axiosGet({
        url: `/notifications/approved_comps`,
        method: 'get',
        baseURL: baseUrlV2,
    });
};

export const getUsersRequest = id => {
    if (id) {
        return axiosGet({
            url: `/notifications/users_by_company/${id}`,
            method: 'get',
            baseURL: baseUrlV2,
        });
    }

    return axiosGet({ url: `/notifications/registered_users/${id}`, method: 'get', baseURL: baseUrlV2 });
};

export const getNonUsersRequest = () => {
    return axiosGet({ url: '/notifications/non_users/all', baseURL: baseUrlV2, method: 'get' });
};

export const setNotificationsRequest = (userType, data) => {
    const url = `/notifications${userType === 'nonusers' ? '/non_users' : '/registered_users'}/whitelist`;
    return axios({ url, method: 'post', baseURL: baseUrlV2, data });
};

export const unsetNotificationsRequest = (userType, data) => {
    const url = `/notifications${userType === 'nonusers' ? '/non_users' : '/registered_users'}/whitelist`;
    return axios({ url, method: 'delete', baseURL: baseUrlV2, data });
};

export const addNonUserRequest = data => {
    return axios({ url: '/notifications/non_users/', method: 'post', baseURL: baseUrlV2, data });
};

export const deleteNonUserRequest = id => {
    return axios({ url: `/notifications/non_users/${id}`, method: 'delete', baseURL: baseUrlV2 });
};

export const sendCustomNotificationRequest = data => {
    return axios({ url: '/notifications/custom/', method: 'post', baseURL: baseUrl, data });
};

// Companies
export const getCompaniesRequest = (approvedOnly, market_id) => {
    let params = {};
    if (approvedOnly) params.approvedOnly = true;
    if (market_id) params.market_id = market_id;
    return axiosGet.get('/companies/all', {params});
}
export const getCompaniesByMarketsRequest = () => {
    return axiosGet.get('/companies/all_by_markets');
}
export const getCompanyRequest = (id='') => {
    return axiosGet.get('/companies/'+id);
}
export const getCountriesRequest = (id='') => {
    return axiosGet.get('/companies/countries'+id);
}
export const blockCompanyRequest = id => {
    return axios.post('/companies/block/'+id);
}
export const updateCompanyAccessRequest = (id, access_type) => {
    return axios.post('/companies/update_access/'+id, { access_type });
}
export const deleteCompanyRequest = id => {
    return axios.delete('/companies/'+id);
}

// Markets
export const getMarketLogRequest = params => {
    return axios.post('/orders/search', params);
};
// Manage Markets

export const killRelatedToUserAndOpenByScope = scope => {
    return axios.delete('/orders/kill/'+scope);
}

// Markets
export const getMarketsRequest = (isShowHidden) => {
    return axiosGet({
        baseURL: baseUrlV2,
        method: 'get',
        url: '/markets/allforsignup',
        params: { isShowHidden },
    });
};

export const getMarketsAllRequest = (isShowHidden) => {
    return axiosGet({
        baseURL: baseUrlV2,
        method: 'get',
        url: '/markets/all',
        params: { isShowHidden },
    });
};

// Manage Markets
export const manageMarketRequest = (mode, data) => {
    return axios({
        baseURL: baseUrlV2,
        method: mode === 'create' ? 'post' : 'put',
        url: '/markets/',
        data,
    });
};

export const deleteMarketRequest = id => {
    return axios({
        baseURL: baseUrlV2,
        method: 'delete',
        url: `/markets/${id}`,
    });
};

// CUSTOM VIEWS
export const getCustomViewsRequest = () => {
    return axiosGet({ url: '/custom_views', method: 'get', baseURL: baseUrlV2 });
};

export const saveCustomViewRequest = (mode, params) =>
    axios({
        baseURL: baseUrlV2,
        method: mode === 'create' ? 'post' : 'put',
        url: '/custom_views',
        data: params,
    });

export const deleteCustomViewRequest = id =>
    axios({
        baseURL: baseUrlV2,
        method: 'delete',
        url: `/custom_views/${id}`,
    });

export const hideCustomViewRequest = (id, data) =>
    axios({
        method: 'put',
        url: `/custom_views/${id}/hide`,
        data,
        baseURL: baseUrlV2,
    });

//Manage Products
export const manageProductRequest = (mode, data) => {
    return axios({
        method: mode=='create' ? 'post' : 'put',
        url: '/products/',
        data
    });
}
export const hideProductRequest = (id, data) => {
    return axios({
        method: 'put',
        url: '/products/'+id+'/hide',
        data
    });
}
export const deleteProductRequest = id => {
    return axios.delete('/products/'+id);
}
export const getProductsRequest = () => {
    return axiosGet.get('/products/all');
}

export const getContactTemplates = () => {
    return axiosGet.get('/products/contract_templates');
}

//Orders
export const getOrdersRequest = type => {
    let action;
    switch(type) {
        case 'workingOrders':
            action = 'allopenorders';
            break;
        case 'openPositions':
            action = 'allopenpositions';
            break;
        case 'settledTrades':
            action = 'allsettledorders';
            break;
        case 'lastTraded':
            action = 'lastclosedorders';
            break;            
    }

    return axiosGet.get('/orders/'+action);
}

export const deleteWorkingOrdersRequest = () => {
    return axios.delete('/orders/allopenorders');
}

export const getOrderRequest = id => {
    return axiosGet.get('/orders/'+id);
}

export const deleteOrderRequest = id => {
    return axios.delete('/orders/'+id);
}

export const updateAndSubmitOrder = (mode, reqProps) => {
    if (mode=='create-finalised') {
        return axios.post('/orders/finalized/', reqProps)
    } else {
        return axios({
            method: (mode=='create' || mode=='duplicate') ? 'post' : 'put',
            url: '/orders/',
            data: reqProps
        });
    }
}

export const placeBidRequest = formData => {
    return axios.post('/orders/bids/', formData);
}

export const setShowTradedRequest = (id, value) => {
    const params = {
        id,
        show_traded: value
    }
    return axios.post('/orders/show_traded/', params);
}

// System log
export const getSystemLogRequest = params => {
    return axios({ url: '/logs/system', method: 'get', baseURL: baseUrlV2, params });
};

// Transactions log
export const getTransactionLogRequest = params => {
    return axios({ url: '/logs/transactions', method: 'get', baseURL: baseUrlV2, params });
};


//Manage counter party filter
export const getTradePermissions = (market_id='') => {
    return axiosGet.get('/comp_to_comp/readAll/'+market_id);
}

export const setTradePermissions = data => {
    return axios.put('/comp_to_comp/set', data);
}

export const setTradePermissionsAll = data => {
    return axios.put('/comp_to_comp/set_all', data);
}


// Indices
export const getAllIndicesRequest = () => {
    return axiosGet.get('/product_indicies/readAll');
};

export const getLatestIndexRequest = productId => {
    return axiosGet({
        url: `/product_indicies/readLatest/${productId}`,
        method: 'get',
        baseURL: baseUrlV2,
    });
};

export const getIndexByMaketIdRequest = (date, market_id) => {
    return axiosGet.get(`/product_indicies/readmarket/${date}/${market_id}`);
};

export const getIndexByMaketIdRequestV2 = (date, market_id, frequencyType) => {
    return axiosGet({
        url: `/product_indicies/readmarket/${date}/${market_id}/${frequencyType}`,
        method: 'get',
        baseURL: baseUrlV2,
    });
};

export const addIndexRequest = params => {
    return axios.post('/product_indicies/add', params);
}
export const deleteIndexRequest = params => {
    return axios.post('/product_indicies/delete', params);
}
export const updateIndexRequest = params => {
    return axios.post('/product_indicies/edit', params);
}
export const indexSettlementRequest = params => {
    return axios.post('/product_indicies/indexSettlement', params);
}
export const indexSettlementReportRequest = params => {
    return axios.post('/product_indicies/sendSettlementReport', params);
}

export const getScheduleRequest = (marketId, year, frequencyType, sortDir) => {
    const params = { marketId, year, frequencyType, sortDir };
    return axiosGet({
        url: '/indices_schedule',
        method: 'get',
        params,
        baseURL: baseUrlV2,
    });
};

export const saveScheduleRequest = (marketId, year, selectedDays, frequencyType) => {
    const params = { marketId, year, selectedDays, frequencyType };
    return axios({
        url: '/indices_schedule',
        method: 'post',
        data: params,
        baseURL: baseUrlV2,
    });
};

// Freight types
export const getFreightTypesRequest = () =>
    axiosGet({
        baseURL: baseUrlV2,
        method: 'get',
        url: `/freights/`,
    });

export const deleteFreightTypeRequest = id =>
    axiosGet({
        baseURL: baseUrlV2,
        method: 'delete',
        url: `/freights/${id}`,
    });

export const manageFreightTypeRequest = (mode, data) =>
    axios({
        baseURL: baseUrlV2,
        method: mode === 'create' ? 'post' : 'put',
        url: '/freights/',
        data,
    });

export const getShowableFreights = () =>
    axiosGet({
        baseURL: baseUrlV2,
        method: 'get',
        url: '/freights/show',
    });



// WEBPACK FOOTER //
// ./source/services/api.js